import { render, staticRenderFns } from "./businessApply.vue?vue&type=template&id=768163c4&scoped=true"
import script from "./businessApply.vue?vue&type=script&lang=js"
export * from "./businessApply.vue?vue&type=script&lang=js"
import style0 from "./businessApply.vue?vue&type=style&index=0&id=768163c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768163c4",
  null
  
)

export default component.exports